import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { AirportNonRefundableMessage, UnrefundedModal } from '@repo/components';
import { Button } from '@successmode-ktp/kui';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { ICON_ARROW_LEFT } from '@repo/assets';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { routes } from '@/constants/routes.const';
import { useMutation } from 'react-query';
import { postExecuteAirport } from '@/api';
import { useState } from 'react';

const AirportNonRefundable = () => {
  const history = useHistory();
  const { departureDate, nationality, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const [isOpen, setIsOpen] = useState(false);

  const { mutate: executeAirport } = useMutation(
    () => postExecuteAirport(passportNumber!),
    {
      onSuccess: () => {
        setIsOpen(true);
      },
      onError: (error) => {
        // 에러 알림 모달
        console.error('Error executing airport:', error);
        alert('Failed to execute airport action. Please try again.');
        if (departureDate) {
          history.push(routes.home);
        } else {
          history.push('/departure');
        }
      },
      retry: false,
    },
  );

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    next: ['Get Refund to bank account', '은행 계좌로 환급받기'],
  };

  return (
    <ReceiptLayout>
      <Content>
        <BackButton onClick={() => history.goBack()}>
          <img src={ICON_ARROW_LEFT} alt='뒤로 가기' width={24} />
        </BackButton>
        <AirportNonRefundableMessage nationality={nationality} />
      </Content>
      <Footer>
        <Button
          style={{
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          }}
          size='lg'
          onClick={() => executeAirport()}
        >
          {text.next[nationIndex]}
        </Button>
      </Footer>
      <UnrefundedModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          if (departureDate) {
            history.push(routes.home);
          } else {
            history.push('/departure');
          }
        }}
        nationality={nationality}
        title={
          nationality === 'KOR'
            ? '구매 물품 세관 미확인 출국'
            : 'Departure Without Customs Clearance'
        }
      />
    </ReceiptLayout>
  );
};

const BackButton = styled.button`
  width: 24px;
  height: 24px;
  margin-top: 20px;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
`;

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px 20px 36px 20px;
  box-shadow: 0px -4px 8px 0px rgba(106, 106, 106, 0.25);
  background-color: #fff;
`;

export default AirportNonRefundable;
